import { connect } from 'react-redux'
import Scene from './scene'
import { getFetchRequest } from '../../../../../stores/works/works.selectors'

const mapStateToProps = state => {
  const fetchRequest = getFetchRequest(state)
  return {
    pending: fetchRequest.pending
  }
}

export default connect(
  mapStateToProps,
  null
)(Scene)
